import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeneralConfigService {

  constructor(private http: HttpClient) {
  }
  
  getGeneralConfigFeatures() {
    return this.http.get(`${environment.apiUrl}/admin/v1/general-config/features`);
  }
}
